module.exports = __webpack_public_path__ + "img/fz.cdab6ea3.png";